import { render } from "./PendingPayments.vue?vue&type=template&id=588890f0"
import script from "./PendingPayments.vue?vue&type=script&lang=js"
export * from "./PendingPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__